import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'

export const initialState = createAsyncObject({})

export const reducers = (state = initialState) => produce(state, () => {})
